import React from 'react';

const ServiceStatus = () => <div>ServiceStatus</div>;

export default ServiceStatus;
